import Vue from 'vue';
import VueRouter from 'vue-router';
import { waitForAuth } from '@/firebase';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { guestOnly: true },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue'),
    meta: { guestOnly: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/CheckoutReturnView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
  },
  {
    path: '/vision',
    name: 'vision',
    component: () => import('../views/VisionView.vue'),
  },
  {
    path: '/mission',
    name: 'mission',
    component: () => import('../views/MissionView.vue'),
  },
  {
    path: '/strategies',
    name: 'strategies',
    component: () => import('../views/StrategiesView.vue'),
  },
  {
    path: '/under',
    name: 'under',
    component: () => import('../views/UnderConstructionView.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
  },
  {
    path: '/ourteam',
    name: 'ourteam',
    component: () => import('../views/OurteamView.vue'),
  },
  {
    path: '/socratic',
    name: 'socratic',
    component: () => import('../views/SocraticView.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsofServiceView.vue'),
  },{
    path: '/development',
    name: 'development',
    component: () => import('../views/DevelopmentTechView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
  },
  {
    path: '/pilot',
    name: 'pilot',
    component: () => import('../views/PilotProgramView.vue'),
  },
  {
    path: '/stem',
    name: 'stem',
    component: () => import('../views/StemView.vue'),
  },
  {
    path: '/articles',
    name: 'articles',
    component: () => import('../views/FutureOfEducationView.vue'),
  },
  {
    path: '/events35',
    name: 'events35',
    component: () => import('../views/Events35View.vue'),
  },
  {
    path: '/events34',
    name: 'events34',
    component: () => import('../views/Events34View.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/DemoProgressView.vue'),
  },
  {
    path: '/tech-support',
    name: 'tech-support',
    component: () => import('../views/TechSupportView.vue'),
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('../views/PortfolioView.vue'),
  },
  {
    path: '/techinnovation',
    name: 'techinnovation',
    component: () => import('../views/TechInnovationView.vue'),
  },
  {
    path: '/ideas',
    name: 'ideas',
    component: () => import('../views/ContentIdeasView.vue'),
  },
  {
    path: '/store',
    name: 'store',
    component: () => import('../views/StoreView.vue'),
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('../views/OrdersView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/checkout/success',
    name: 'checkout-success',
    component: () => import('../views/CheckoutSuccessView.vue'),
  },
  {
    path: '/checkout/cancel',
    name: 'checkout-cancel',
    component: () => import('../views/CheckoutCancelView.vue'),
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/SupportView.vue'),
    meta: { requiresAuth: true, title: 'Support Center' }
  },
  {
    path: '/admin/support',
    name: 'support-admin',
    component: () => import('../views/SupportAdminView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/roles',
    name: 'roles-admin',
    component: () => import('../views/AssignRolesView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/aprende',
    name: 'aprende',
    component: () => import('../views/AprendeView.vue'),
  },
  // Ruta para manejar 404
  {
    path: '*',
    name: 'notfound',
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// ── Guard de navegación ────────────────────────────────────────────────────────
// waitForAuth() espera a que Firebase restaure la sesión antes de decidir.
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(r => r.meta.requiresAuth);
  const guestOnly    = to.matched.some(r => r.meta.guestOnly);

  const user = await waitForAuth();

  if (requiresAuth && !user) {
    next({ name: 'login', query: { redirect: to.fullPath } });
  } else if (guestOnly && user) {
    next({ name: 'profile' });
  } else {
    next();
  }
});

export default router;